<template>
  <div class="about-section">
    <div class="container">
      <div class="about-content">
        <div class="about-header">
          <div class="report-title">关于我们<span style="color: #F66F00;text-align: center !important;">•</span></div>
          <div class="news-subtitle">ABOUT US</div>
        </div>
        <div v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { aboutUsConfig } from '@/api'
export default {
  data() {
    return {
      content: ''
    }
  },
  mounted() {
    this.getContent()
  },
  methods: {
    getContent() {
      aboutUsConfig().then(res => {
        if (res.code === 1) {
          this.content = res.data.about_us_content.value
        }
      })
    }
  }
}
</script>

<style scoped>
.about-section{
  padding: 60px 0;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.about-header{
  text-align: center;
}
.report-title {
  font-size: 30px;
  color: #1B5AFF;
  margin-bottom: 0;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
}
.news-subtitle {
  font-size: 24px;
  color: #DDE4EA;
  /* margin-bottom: 30px; */
}
.about-content{
  padding: 50px;
  background: #ffffff;
  border-radius: 10px;
}
</style>